import React, { useState } from 'react';
import DocumentIcon from "../../shared/icons/DocumentIcon";
import PlusIcon from "../../shared/icons/PlusIcon";
import cn from "classnames";
import commonStyle from "../section-item/common.module.scss"
import style from "./index.module.scss";
import PhotoViewer from "./PhotoViewer";
import CloseIcon from "../../shared/icons/CloseIcon";
import { File } from "../../../services";
import { toast } from "react-toastify";

const OrdersDocumentCard = ({
  fileId = null,
  text = "",
  isAddButton = false,
  allowClearFile = false,
  onUploadFile,
  onClearFile,
  withIcon = true,
  errorText = "",
}) => {
  const randomId = String.fromCharCode(65 + Math.floor(Math.random() * 26));
  const [isOpen, setIsOpen] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState(null);

  const handleEvent = (event) => {
    if (isAddButton) {
      onUploadFile(event.target.files[0])
    }
  }

  const downloadFile = () => {
    console.log("fileId", fileId)
    if (!fileId) {
      return
    }

    // toast.info("Запрос на получение файла, отправлен.")
    File.downloadFileById(fileId)
      .then(res => res.data)
      .then(data => {
        console.log(data)
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);

        setCurrentPhoto({ url: url });
        setIsOpen(true);
      })
      .catch(e => {
        toast.error("Произошла ошибка, попробуйте позже")
      })
  }

  const handleClose = () => {
    setIsOpen(false);
  }

  if (isAddButton) {
    return (
      <div>
        <label
          htmlFor={"upload-files-" + randomId}
          className={cn(style.documentCard, commonStyle.cardItem, style.documentCard_add)}
          style={errorText ? { borderColor: '#C84620' } : undefined}
        >
          <PlusIcon className={style.documentCard_icon} />
          <span className={style.documentCard_text}>{text || "Добавить документ"}</span>
          <input
            className={'position-absolute'}
            id={"upload-files-" + randomId}
            type="file"
            onChange={handleEvent}
          />
        </label>
        {errorText && <div style={{ color: '#C84620', fontSize: '12px', marginTop: '4px' }}>{errorText}</div>}
      </div>
    )
  }
  return (
    <div className=''>
      <h5
        className={cn(style.documentCardPhoto_text)}
      >
        Фото накладной
      </h5>

      <div className={cn(style.documentCard, commonStyle.cardItem, {
        [style.cursor]: fileId
      })} onClick={downloadFile} style={errorText ? { borderColor: '#C84620' } : undefined}>
        {withIcon && <DocumentIcon className={style.documentCard_icon} />}
        <span className={style.documentCard_text}>{text}</span>
        {
          allowClearFile && <span className={style.documentCard_close}>
            <CloseIcon width={16} height={16} onClick={onClearFile} fill={'#909195'} />
          </span>
        }
      </div>
      {errorText && <div style={{ color: '#C84620', fontSize: '12px', marginTop: '4px' }}>{errorText}</div>}
      {isOpen && <PhotoViewer currentPhoto={currentPhoto} onClose={handleClose} />}
    </div>
  );
};

export default OrdersDocumentCard;